
import { Component, inject } from '@angular/core';
import { IonContent, IonHeader, IonToolbar, IonTitle, IonButton, IonIcon, ModalController } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { shareOutline } from 'ionicons/icons';

@Component({
  selector: 'app-ios-install-modal',
  templateUrl: './ios-install-modal.component.html',
  styleUrls: ['./ios-install-modal.component.scss'],
  standalone: true,
  imports: [IonContent, IonHeader, IonToolbar, IonTitle, IonButton, IonIcon]
})
export class IosInstallModalComponent {
  private modalCtrl = inject(ModalController);

  constructor() {
    addIcons({ shareOutline });
  }

  close() {
    this.modalCtrl.dismiss();
  }
}